import { api } from "@api/api";
import { Sector } from "@modules/bookSectors/types";
import { SectorFormValues } from "@modules/bookSectors/validations";

export async function createSectorService(data: SectorFormValues): Promise<Sector> {
  const { data: sector } = await api.post<Sector>("v1/book_sector_admin/", data);

  return sector;
}
